export default function Card({ children, className = "", as: Tag = "div", ...rest }) {
  return (
    <Tag
      className={`bg-terakkiSurface border border-terakkiBorder rounded-lg p-4 shadow-sm dark:bg-white/5 dark:border-white/15 dark:shadow-none ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
